module.exports = __webpack_public_path__ + "static/media/travicar_atomizador.164babc2.png";